import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LxlibUtilModule } from '@lxlib/util';
import { FullContentToggleDirective } from './full-content-toggle.directive';
import { FullContentComponent } from './full-content.component';

const COMPONENTS = [FullContentComponent, FullContentToggleDirective];

@NgModule({
  imports: [CommonModule, LxlibUtilModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class FullContentModule {}
